import React, { useState, useEffect } from 'react';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { useFormErrors } from '../../hooks/useFormErrors';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import {object, func, bool, string} from 'prop-types';
import {CloneObject, GetMeses} from '../../../utils/helpers';
import { DatePickerCustom, InputEntidad, InputEjercicio, InputCodigo, InputNumber, Loading, Accordion, FormLabel, Modal, Select, FormError } from '../../common';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import DeclaracionJuradaArchivosGrid from '../DeclaracionJuradaArchivosGrid';
import {usePermissions} from '../../hooks/usePermissions';
import {PERMISSIONS} from '../../../consts/permissions';
import {getDateId} from '../../../utils/convert';
import {isNull} from '../../../utils/validator';
import {UNIDAD_MEDIDA} from '../../../consts/unidadMedida';
import {APIS} from '../../../config/apis';
import {ServerRequest} from '../../../utils/apiweb';
import {TIPS} from "../../../consts/tips";
import {PERIODICIDAD_DECLARACION_JURADA} from '../../../consts/periodicidadDeclaracionJurada';

const ANCHOS_TIPO_DDJJ = {
    INGRESO_ANUAL: 'col-md-8',
    EMPLEADOS: 'col-md-4',
};

const PERIODOS_DDJJ = {
    [PERIODICIDAD_DECLARACION_JURADA.BIMESTRAL]: { nombre: 'Bimestre', cantidad: 6 },
    [PERIODICIDAD_DECLARACION_JURADA.TRIMESTRAL]: { nombre: 'Trimestre', cantidad: 4 },
    [PERIODICIDAD_DECLARACION_JURADA.SEMESTRAL]: { nombre: 'Semestre', cantidad: 2 }
};

const DeclaracionJuradaModal = (props) => {

    const { hasPermission } = usePermissions();
    const canViewDeclaracionJurada = hasPermission(PERMISSIONS.DECLARACION_JURADA_VIEW);

    const entityInit = {
        id: 0,
        idCuenta: 0,
        idModeloDeclaracionJurada: 0,
        fechaPresentacionDeclaracionJurada: null,
        anioDeclaracion: '',
        mesDeclaracion: 0,
        numero: '',
        idOrigenDeclaracionJurada: 0,
        fechaAlta: null,
        fechaBaja: null,
        resolucion: '',
        declaracionJuradaItems: []
    };
    const modeloInit = {
        id: 0,
        codigo: "",
        nombre: "",
        orden: 0,
        idTipoTributo: 0,
        idPeriodicidadDeclaracionJurada: 0,
        idTipoModeloDeclaracionJurada: 0,
        activo: false,
        observacion: "",
        clasesDeclaracionJurada: []
    };
    const rubroInit = {
        id: 0,
        codigo: "",
        nombre: "",
        orden: 0,
        agrupamiento: "",
        fechaBaja: null,
        facturable: false,
        generico: false,
        categoria: "",
        importeMinimo: 0,
        alicuota: 0,
        regimenGeneral: true,
        idTipoMinimoAplicable: 0,
        esRubroPrincipal: false,
        tiposDeclaracionJurada: []
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
        idTipoTributo: 0,
        idPeriodicidadDeclaracionJurada: 0
    });

    const [modelo, setModelo] = useState(modeloInit);
    const [loading, setLoading] = useState(false);
    const [definicionOpen, setDefinicionOpen] = useState(true);


    const mount = () => {
        setState(prevState => {
            return {
                ...prevState,
                entity: props.data.entity,
                idTipoTributo: props.data.idTipoTributo
            };
        });

        formSet({
            idCuenta: props.data.entity.idCuenta,
            idModeloDeclaracionJurada: props.data.entity.idModeloDeclaracionJurada,
            fechaPresentacionDeclaracionJurada: props.data.entity.fechaPresentacionDeclaracionJurada,
            anioDeclaracion: props.data.entity.anioDeclaracion,
            mesDeclaracion: props.data.entity.mesDeclaracion,
            numero: props.data.entity.numero,
            idOrigenDeclaracionJurada: props.data.entity.idOrigenDeclaracionJurada,
            fechaAlta: props.data.entity.fechaAlta,
            fechaBaja: props.data.entity.fechaBaja,
            resolucion: props.data.entity.resolucion
        });
    }
    useEffect(mount, [props.data.entity]);

    useEffect(() => {
        let newFormTipoValues = {};
        modelo.clasesDeclaracionJurada.forEach(clase => {
            const rubrosXClase = clase.aplicaRubro ? clase.rubros : [rubroInit];
            rubrosXClase.forEach(rubro => {
                clase.tiposDeclaracionJurada.filter(f => !clase.aplicaRubro || rubro.tiposDeclaracionJurada.includes(f.id)).forEach(tipo => {
                    const item = state.entity.declaracionJuradaItems.find(x => x.idTipoDeclaracionJurada === tipo.id && (isNull(x.idRubro) || x.idRubro === rubro.id));
                    newFormTipoValues[`tipo_${rubro.id}_${tipo.id}`] = item ? item.valor : 0;
                });
            });
        });
        formTipoSet(newFormTipoValues);
    }, [modelo]);

    const [formValues, formHandle, , formSet] = useForm({
        idCuenta: 0,
        idModeloDeclaracionJurada: 0,
        fechaPresentacionDeclaracionJurada: null,
        anioDeclaracion: '',
        mesDeclaracion: 0,
        numero: '',
        idOrigenDeclaracionJurada: 0,
        fechaAlta: null,
        fechaBaja: null,
        resolucion: ''
    });

    const [formTipoValues, formTipoHandle, , formTipoSet] = useForm({});

    useEffect(() => {
        if (state.entity.id > 0) return;

        if (formValues.idModeloDeclaracionJurada > 0 && formValues.anioDeclaracion.length === 4 && formValues.mesDeclaracion > 0) {
            const count = props.data.list.filter(item =>
                item.idModeloDeclaracionJurada === formValues.idModeloDeclaracionJurada &&
                item.anioDeclaracion === formValues.anioDeclaracion &&
                item.mesDeclaracion === formValues.mesDeclaracion
            ).length;
            formSet({ ...formValues, numero: String(count)});
            FindModeloDeclaracionJurada(formValues.idModeloDeclaracionJurada);
        }
        else {
            if (modelo.id > 0) {
                formSet({ ...formValues, numero: '' });
                setModelo(modeloInit);
            }
        }

    }, [formValues.idModeloDeclaracionJurada, formValues.anioDeclaracion, formValues.mesDeclaracion]);

    const { errorOf, validate } = useFormErrors(getErrors);

    const periodo = PERIODOS_DDJJ[state.idPeriodicidadDeclaracionJurada];
    const opcionesPeriodo = (periodo)
        ? Array.from({ length: periodo.cantidad }, (_, index) => ({ value: index + 1, label: `${index + 1}° ${periodo.nombre}` }))
        : GetMeses().map(item => ({value: item.key, label: item.name}));

    //handles
    const handleClickAceptar = () => {
        if (Object.keys(getErrors()).length > 0) setDefinicionOpen(true);

        if (validate()) {
            if (formValues.numero.length <= 0) {
                ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'No se pudo calcular el número de la declaración');
                return;
            }

            let row = CloneObject(state.entity);
            row.idModeloDeclaracionJurada = parseInt(formValues.idModeloDeclaracionJurada);
            row.fechaPresentacionDeclaracionJurada = formValues.fechaPresentacionDeclaracionJurada;
            row.anioDeclaracion = formValues.anioDeclaracion;
            row.mesDeclaracion = formValues.mesDeclaracion;
            row.numero = formValues.numero;
            row.idOrigenDeclaracionJurada = parseInt(formValues.idOrigenDeclaracionJurada);
            row.fechaAlta = formValues.fechaAlta;
            row.fechaBaja = formValues.fechaBaja;
            row.resolucion = formValues.resolucion;

            if (formValues.fechaAlta == null) {
                row.fechaAlta = row.fechaPresentacionDeclaracionJurada
            }

            let idTemporal = parseInt(getDateId());
            modelo.clasesDeclaracionJurada.forEach(clase => {
                const rubrosXClase = clase.aplicaRubro ? clase.rubros : [rubroInit];
                rubrosXClase.forEach(rubro => {
                    clase.tiposDeclaracionJurada.filter(f => !clase.aplicaRubro || rubro.tiposDeclaracionJurada.includes(f.id)).forEach((tipo, index) => {
                        let item = row.declaracionJuradaItems.find(x => x.idTipoDeclaracionJurada === tipo.id && (isNull(x.idRubro) || x.idRubro === rubro.id));
                        if (item) {
                            item.valor = formTipoValues[`tipo_${rubro.id}_${tipo.id}`];
                            item.state = item.id > 0 ? 'm' : 'a';
                        } else {
                            item = {
                                id: (-1) * (idTemporal + index), //los registros temporales tienen id negativa
                                idCuenta: row.idCuenta,
                                idRubro: rubro.id,
                                idDeclaracionJurada: row.id,
                                idClaseDeclaracionJurada: tipo.idClaseDeclaracionJurada,
                                idTipoDeclaracionJurada: tipo.id,
                                valor: formTipoValues[`tipo_${rubro.id}_${tipo.id}`],
                                state: 'a'
                            };
                            row.declaracionJuradaItems.push(item);
                        }
                    });
                });
            });

            props.onConfirm(row);
        }
        ;
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idModeloDeclaracionJurada <= 0) errors.idModeloDeclaracionJurada = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.fechaPresentacionDeclaracionJurada == null) errors.fechaPresentacionDeclaracionJurada = VALIDATION_MESSAGE.REQUIRED_DATE;
        if (formValues.anioDeclaracion.length === 0) errors.anioDeclaracion = VALIDATION_MESSAGE.REQUIRED;
        else if (formValues.anioDeclaracion.length < 4) errors.anioDeclaracion = 'Ingresá 4 dígitos';
        if (formValues.mesDeclaracion <= 0) errors.mesDeclaracion = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.idOrigenDeclaracionJurada <= 0) errors.idOrigenDeclaracionJurada = VALIDATION_MESSAGE.REQUIRED_OPTION;

        return errors;
    }

    const callbackNoSuccess = (response) => {
        response.json()
            .then((error) => {
                const message = error.message;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setLoading(false);
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setLoading(false);
            });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setLoading(false);
    }

    function FindModeloDeclaracionJurada(idModeloDeclaracionJurada) {
        setLoading(true);

        const callbackSuccess = (response) => {
            response.json()
                .then((data) => {
                    setModelo(data);
                    setLoading(false);
                })
                .catch((error) => {
                    const message = 'Error procesando respuesta: ' + error;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                  setLoading(false);
                });
        };

        const paramsUrl = `/${idModeloDeclaracionJurada}/cuenta/${state.entity.idCuenta}/anio/${formValues.anioDeclaracion}/mes/${formValues.mesDeclaracion}`;

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.MODELO_DECLARACION_JURADA,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    return (
        <>

            <Loading visible={loading}></Loading>

            <Modal
                size="xl"
                allowFullscreen
                title="Declaración jurada"
                tipName={TIPS.NAME.MODALS.DECLARACION_JURADA_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">

                                <div className="m-top-10 col-12">
                                    <Accordion title="Definición de declaración jurada" open={definicionOpen} onToggle={setDefinicionOpen}>
                                            <div className="row form-basic">
                                                <div className="mb-3 col-12 col-md-4">
                                                    <FormLabel htmlFor="idModeloDeclaracionJurada" required>Modelo
                                                        DDJJ</FormLabel>
                                                    <InputEntidad
                                                        name="idModeloDeclaracionJurada"
                                                        placeholder=""
                                                        tipName={TIPS.NAME.MODALS.MODELO_DECLARACION_JURADA_MODAL}
                                                        className={`form-control ${errorOf('idModeloDeclaracionJurada') ? 'is-invalid' : ''}`}
                                                        value={formValues.idModeloDeclaracionJurada}
                                                        onChange={({target}) => {
                                                            formSet({...formValues, idModeloDeclaracionJurada: target.value, mesDeclaracion: 0});
                                                        }}
                                                        onUpdate={({target}) => {
                                                            setState(prevState => ({...prevState, idPeriodicidadDeclaracionJurada: target.row?.idPeriodicidadDeclaracionJurada ?? 0}));
                                                            if (target.row && state.entity.id > 0)
                                                                FindModeloDeclaracionJurada(target.row.id);
                                                            // else
                                                            //     setModelo(modeloInit);
                                                        }}
                                                        disabled={props.disabled || state.entity.id > 0}
                                                        title="Modelo DDJJ"
                                                        entidad="ModeloDeclaracionJurada"
                                                        filter={(row) => (row.idTipoTributo === state.idTipoTributo && (row.activo || state.entity.id > 0))}
                                                    />
                                                    <FormError message={errorOf('idModeloDeclaracionJurada')} />
                                                </div>
                                                <div className="mb-3 col-6 col-md-3">
                                                    <FormLabel htmlFor="fechaPresentacionDeclaracionJurada"
                                                           required>Fecha de presentación</FormLabel>
                                                    <DatePickerCustom
                                                        name="fechaPresentacionDeclaracionJurada"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('fechaPresentacionDeclaracionJurada') ? 'is-invalid' : ''}`}
                                                        value={formValues.fechaPresentacionDeclaracionJurada}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('fechaPresentacionDeclaracionJurada')} />
                                                </div>
                                                <div className="mb-3 col-6 col-md-2">
                                                    <FormLabel htmlFor="anioDeclaracion" required>Año</FormLabel>
                                                    <InputEjercicio
                                                        name="anioDeclaracion"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('anioDeclaracion') ? 'is-invalid' : ''}`}
                                                        value={formValues.anioDeclaracion}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('anioDeclaracion')} />
                                                </div>
                                                <div className="mb-3 col-6 col-md-2">
                                                    <FormLabel htmlFor="mesDeclaracion" required>{(periodo) ? 'Período' : 'Mes'}</FormLabel>
                                                    <Select
                                                        name="mesDeclaracion"
                                                        className={`form-control ${errorOf('mesDeclaracion') ? 'is-invalid' : ''}`}
                                                        value={formValues.mesDeclaracion}
                                                        options={opcionesPeriodo}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('mesDeclaracion')} />
                                                </div>
                                                <div className="mb-3 col-6 col-md-1">
                                                    <label htmlFor="numero" className="form-label">Número</label>
                                                    <InputCodigo
                                                        name="numero"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.numero}
                                                        onChange={formHandle}
                                                        disabled={true}
                                                        maxLength={20}
                                                    />
                                                    <FormError />
                                                </div>
                                                <div className="mb-3 col-12 col-md-4">
                                                    <FormLabel htmlFor="idOrigenDeclaracionJurada" required>Origen
                                                        DDJJ</FormLabel>
                                                    <InputEntidad
                                                        name="idOrigenDeclaracionJurada"
                                                        placeholder=""
                                                        tipName={TIPS.NAME.MODALS.ORIGEN_DECLARACION_JURADA_MODAL}
                                                        className={`form-control ${errorOf('idOrigenDeclaracionJurada') ? 'is-invalid' : ''}`}
                                                        value={formValues.idOrigenDeclaracionJurada}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                        title="Origen DDJJ"
                                                        entidad="OrigenDeclaracionJurada"
                                                    />
                                                    <FormError message={errorOf('idOrigenDeclaracionJurada')} />
                                                </div>
                                                <div className="mb-3 col-6 col-md-2">
                                                    <label htmlFor="fechaAlta" className="form-label">Fecha alta</label>
                                                    <DatePickerCustom
                                                        name="fechaAlta"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.fechaAlta}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="mb-3 col-6 col-md-2">
                                                    <label htmlFor="fechaBaja" className="form-label">Fecha baja</label>
                                                    <DatePickerCustom
                                                        name="fechaBaja"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.fechaBaja}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="mb-3 col-6 col-md-4">
                                                    <label htmlFor="resolucion"
                                                           className="form-label">Resolución</label>
                                                    <input
                                                        name="resolucion"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.resolucion}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                            </div>
                                    </Accordion>
                                </div>

                                {modelo.clasesDeclaracionJurada.map((clase, indexClase) =>
                                    <div className="m-top-20 col-12" key={indexClase}>
                                        <Accordion title={clase.nombre}>
                                                {(clase.aplicaRubro ? clase.rubros : [rubroInit]).map((rubro, indexRubro) =>
                                                    <div className="row form-basic" key={indexRubro}>
                                                        {rubro.id > 0 && <><h3 className="modal-title mb-3">
                                                            <b>Rubro: {rubro.codigo}</b> - {rubro.nombre}</h3></>}
                                                        {clase.tiposDeclaracionJurada.filter(f => !clase.aplicaRubro || rubro.tiposDeclaracionJurada.includes(f.id)).map((tipo, indexTipo) => {
                                                            const colClass = ANCHOS_TIPO_DDJJ[tipo.codigo] || 'col-md-6';
                                                            return (
                                                                <div className={`mb-3 col-12 ${colClass}`} key={indexTipo}>
                                                                    <label htmlFor={`tipo_${rubro.id}_${tipo.id}`}
                                                                           className="form-label">{tipo.nombre}</label>
                                                                    <InputNumber
                                                                        name={`tipo_${rubro.id}_${tipo.id}`}
                                                                        placeholder=""
                                                                        className="form-control"
                                                                        precision={tipo.idUnidadMedida === UNIDAD_MEDIDA.UNIDADES_DECIMALES || tipo.idUnidadMedida === UNIDAD_MEDIDA.IMPORTE ? 2 : 0}
                                                                        value={formTipoValues[`tipo_${rubro.id}_${tipo.id}`]}
                                                                        onChange={formTipoHandle}
                                                                        disabled={props.disabled}
                                                                    />
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                        </Accordion>
                                    </div>
                                )}

                                {/* Se gatea por permiso y no solo por el id: al expandir el acordeón la
                                    grilla pide el detalle, y un 401 en este front no degrada la
                                    sección —redirige a `unauthorized` y saca al operador de la
                                    pantalla, perdiendo lo que no guardó—. */}
                                {state.entity.id > 0 && canViewDeclaracionJurada && (
                                    <div className="m-top-20 col-12">
                                        <Accordion title="Documentación de la presentación">
                                                <DeclaracionJuradaArchivosGrid
                                                    idDeclaracionJurada={state.entity.id}
                                                    disabled={props.archivosDisabled}
                                                />
                                        </Accordion>
                                    </div>
                                )}

                                <div className="mb-3 m-top-20 col-12">
                                    <Accordion title="Información adicional">
                                            {/* Sin la pestaña de archivos: la documentación de la
                                                presentación va en el acordeón de arriba, contra
                                                `declaracion_jurada_archivo`. La genérica escribiría
                                                en la tabla `archivo`, invisible desde ahí. */}
                                            <DataTaggerFormRedux
                                                title="Información adicional de Declaraciones juradas"
                                                tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_DECLARACIONES_JURADAS_MODAL}
                                                processKey={props.processKey}
                                                entidad="DeclaracionJurada"
                                                idEntidad={state.entity.id}
                                                disabled={props.disabled}
                                                ocultarArchivos
                                            />
                                    </Accordion>
                                </div>

                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}


DeclaracionJuradaModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    archivosDisabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

DeclaracionJuradaModal.defaultProps = {
    disabled: false,
    archivosDisabled: true
};

export default DeclaracionJuradaModal;